<template>
    <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
</template>

<script>
import ProcessosServicos from './ProcessosServicos'

export default {
    data() {
        return {
            contrato: {},
            erros: []
        }
    },

    methods: {
        obterContratoGestor() {
            this.$store.dispatch('addRequest')
            let contratoId = this.$route.query.c
            ProcessosServicos.obterContratoGestor(contratoId).then(response => {
                if (response) {
                    if (response.success) {
                        this.contrato = response.data
                        this.confirmarFinalizarAvisosSaldoContrato()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmarFinalizarAvisosSaldoContrato() {
            this.$swal({
                title: 'Avisos de Saldo do Contrato',
                html: `Confirma a finalização dos avisos de saldo do contrato <b>${this.contrato.vcCodigoEstruturado}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.finalizarAvisosSaldoContrato(result.value)
                } else {
                    this.$router.push('/')
                }
            })
        },

        finalizarAvisosSaldoContrato() {
            this.$store.dispatch('addRequest')
            let finalizarDto = {
                idContrato: this.$route.query.c,
                percentual: this.$route.query.p
            }
            ProcessosServicos.finalizarAvisosSaldoContrato(finalizarDto).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.finalizacaoRealizadaComSucesso()
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        finalizacaoRealizadaComSucesso() {
            this.$swal({
                title: 'Avisos de Saldo do Contrato',
                html: `Finalizados com Sucesso`,
                icon: 'success'
            }).then(result => {
                if (result.value) {
                    this.$router.push('/')
                }
            })
        }
    },

    created() {
        this.obterContratoGestor()
    }
}
</script>
